import { TextArea } from '@rsos/base-components';
import { ErrorWrapper } from '@rsos/base-components/form/ErrorsWrapper';
import { Select } from '@rsos/components/capstone/base';
import { useSelectStyles } from '../TowPro/shared';
import FieldLabel from './FieldLabel';
import styles from './NorfolkSouthernForm.module.css';
import {
  visibleFieldError,
  type NorfolkSouthernFormik,
  type SelectOption,
} from './formFieldUtils';
import {
  NORFOLK_SOUTHERN_REASONS,
  REASON_MAX_LENGTH,
  REASON_OTHER,
} from './norfolkSouthernFormUtils';

const REASON_OPTIONS: SelectOption[] = NORFOLK_SOUTHERN_REASONS.map(reason => ({
  value: reason,
  label: reason,
}));

interface ReasonFieldProps {
  formik: NorfolkSouthernFormik;
}

/** The reason dropdown, with a free text box when the reason is Other. */
function ReasonField({ formik }: ReasonFieldProps): JSX.Element {
  const reasonError = visibleFieldError(formik, 'reason');
  const otherReasonError = visibleFieldError(formik, 'otherReason');
  const selectStyles = useSelectStyles(reasonError);

  return (
    <>
      <div className={styles.field}>
        <FieldLabel required>Reason</FieldLabel>
        <Select
          name="reason"
          classNamePrefix="norfolk-southern-reason"
          options={REASON_OPTIONS}
          placeholder="Select a reason"
          isClearable={false}
          isSearchable={false}
          onChange={(option: SelectOption | null) => {
            formik.setFieldValue('reason', option?.value ?? '', true);
            formik.setFieldTouched('reason', true, false);
          }}
          onBlur={() => formik.setFieldTouched('reason', true, false)}
          value={
            REASON_OPTIONS.find(
              option => option.value === formik.values.reason,
            ) ?? null
          }
          styles={selectStyles}
        />
        {reasonError && <ErrorWrapper error={reasonError} />}
      </div>
      {formik.values.reason === REASON_OTHER && (
        <div className={styles.field}>
          <FieldLabel required>Other Reason</FieldLabel>
          <TextArea
            id="otherReason"
            name="otherReason"
            placeholder="What was reported to the ECC?"
            rows={3}
            fontSize="14px"
            maxLength={REASON_MAX_LENGTH}
            value={formik.values.otherReason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {otherReasonError && <ErrorWrapper error={otherReasonError} />}
          <div
            className={styles.helperText}
            data-name="norfolk-southern-reason-count"
          >
            {formik.values.otherReason.length} / {REASON_MAX_LENGTH}
          </div>
        </div>
      )}
    </>
  );
}

export default ReasonField;
